import { render, staticRenderFns } from "./sealInformation.vue?vue&type=template&id=1b8348f8&scoped=true&"
import script from "./sealInformation.vue?vue&type=script&lang=js&"
export * from "./sealInformation.vue?vue&type=script&lang=js&"
import style0 from "./sealInformation.vue?vue&type=style&index=0&id=1b8348f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8348f8",
  null
  
)

export default component.exports